import { render, staticRenderFns } from "./DialogTenderAccept.vue?vue&type=template&id=74a1e065"
import script from "./DialogTenderAccept.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderAccept.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports